// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"154":"0cac35e2d1a486e4b06e","264":"a4ace5193ff40c91bb67","293":"01971562c2049930fcce","700":"6d842c7b6f736b7ba552","752":"d0f501dfffa0fa819bf3","858":"07e385e68a327aa61bbc","938":"111f1116916c628ce3d7"}[chunkId] + ".js";
};